<script>
import { PublicAttachment } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'
import { getFileName } from '../../common/js/imgproxy'

export default {
  mixins: [ListMixin],
  data() {
    return {
      verboseName: 'Public attachment',
      verboseNamePlural: 'Public attachments',
      listFields: [
        {
          prop: 'file',
          label: 'url',
          formatter: attachment => this.getFileName(attachment.file)
        },
        { label: 'data', formatter: this.formatDate('created') }
      ]
    }
  },
  methods: {
    getFileName,
    actions(scope) {
      return []
    }
  },
  computed: {
    service() {
      return PublicAttachment
    }
  }
}
</script>
